import EthereumSigner from "./ethereumSigner.js";
export default class PolygonSigner extends EthereumSigner {
}
//# sourceMappingURL=PolygonSigner.js.map